"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreatorDataApi = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const apiRequest_1 = __importDefault(require("root/src/client/logic/api/thunks/apiRequest"));
const giveaways_constants_1 = require("root/src/shared/giveaways/giveaways.constants");
const creatorDataHof_1 = __importDefault(require("root/src/client/logic/creatorData/util/creatorDataHof"));
const useCreatorDataApi = () => {
    const dispatch = (0, useStore_1.useAppDispatch)();
    const userId = (0, useStore_1.useAppSelector)((0, creatorDataHof_1.default)('userId'));
    const fetchGiveaways = () => {
        return dispatch((0, apiRequest_1.default)(giveaways_constants_1.giveawayEndpointIds.GET_USER_GIVEAWAYS, {
            userId,
        }));
    };
    const fetchRewards = () => {
        return dispatch((0, apiRequest_1.default)(giveaways_constants_1.giveawayEndpointIds.GET_USER_GIVEAWAY_REWARDS, {
            userId,
        }));
    };
    const fetchScheduler = () => {
        return dispatch((0, apiRequest_1.default)(giveaways_constants_1.giveawayEndpointIds.GET_USER_ACTIVE_GIVEAWAY_SCHEDULER, {
            userId,
        }));
    };
    return {
        fetchGiveaways,
        fetchRewards,
        fetchScheduler,
    };
};
exports.useCreatorDataApi = useCreatorDataApi;
